// import React, { useState, useEffect } from 'react';
// import {
//   Container,
//   Box,
//   Typography,
//   Paper,
//   Grid,
//   TextField,
//   MenuItem,
//   Button,
//   CircularProgress,
//   IconButton,
//   Chip,
// } from '@mui/material';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import {
//   Person as PersonIcon,
//   Receipt as ReceiptIcon,
//   TrendingUp as SalesIcon,
//   AccountBalance as BalanceIcon,
//   ArrowBack as BackIcon,
// } from '@mui/icons-material';
// import ReportDataGrid from '../components/ReportDataGrid';
// import reportService from '../services/reportService';
// import { useNavigate } from 'react-router-dom';
// import image from '../assets/riyal.png'

// const CustomerSalesReport = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [reportData, setReportData] = useState([]);
//   const [totals, setTotals] = useState(null);
//   const [customers, setCustomers] = useState([]);
//   const [filters, setFilters] = useState({
//     customerId: '',
//     startDate: new Date(new Date().getFullYear(), 0, 1), // Start of current year
//     endDate: new Date(),
//   });
//   const [selectedCustomer, setSelectedCustomer] = useState('');

//   // Fetch report data
//   const fetchReport = async () => {
//     try {
//       setLoading(true);
//       const params = {
//         customerId: filters.customerId,
//         startDate: filters.startDate?.toISOString().split('T')[0],
//         endDate: filters.endDate?.toISOString().split('T')[0],
//       };

//       const response = await reportService.getCustomerSales(params);

//       if (response.success) {
//         setReportData(response.data || []);
//         setTotals(response.totals);
//         setCustomers(response.customers || []);
//         console.log('Customers loaded:', response.customers?.length);
//         console.log('Customers data:', response.customers);
//         // Set selected customer from response
//         setSelectedCustomer(response.filters?.customerId || '');
//       }
//     } catch (error) {
//       console.error('Error fetching customer sales report:', error);
//       alert('Failed to fetch customer sales report. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch report on mount
//   useEffect(() => {
//     fetchReport();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Handle filter change
//   const handleFilterChange = (field, value) => {
//     setFilters(prev => ({ ...prev, [field]: value }));
//   };

//   // Handle apply filters
//   const handleApplyFilters = () => {
//     fetchReport();
//   };

//   // Handle back
//   const handleBack = () => {
//     navigate('/reports');
//   };

//   // Define columns for DataGrid
//   const columns = [
//     {
//       field: 'customerName',
//       headerName: 'Customer Name',
//       flex: 1.2,
//       minWidth: 200,
//       sortable: true,
//       resizable: true,
//       headerAlign: 'left',
//       align: 'left',
//     },
//     {
//       field: 'customerCode',
//       headerName: 'Customer Code',
//       flex: 0.8,
//       minWidth: 130,
//       sortable: true,
//       resizable: true,
//       headerAlign: 'left',
//       align: 'left',
//     },
//     {
//       field: 'customerType',
//       headerName: 'Type',
//       flex: 0.6,
//       minWidth: 80,
//       resizable: true,
//       headerAlign: 'center',
//       align: 'center',
//       renderCell: (params) => {
//         const type = params.value;
//         const color = type === 'B2B' ? { bg: '#e3f2fd', text: '#1565c0' } : { bg: '#fff3e0', text: '#e65100' };

//         return (
//           <Chip
//             label={type}
//             size="small"
//             sx={{
//               bgcolor: color.bg,
//               color: color.text,
//               fontWeight: 600,
//               fontSize: '0.7rem',
//               height: '22px',
//             }}
//           />
//         );
//       },
//     },
//     {
//       field: 'invoiceCount',
//       headerName: 'Invoices',
//       flex: 0.7,
//       minWidth: 100,
//       type: 'number',
//       resizable: true,
//       align: 'center',
//       headerAlign: 'center',
//     },
//     {
//       field: 'totalSales',
//       headerName: 'Total Sales',
//       flex: 1,
//       minWidth: 140,
//       type: 'number',
//       resizable: true,
//       align: 'right',
//       headerAlign: 'right',
//       valueFormatter: (params) => `SAR ${params.value?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//       cellClassName: () => 'font-weight-bold',
//     },
//     {
//       field: 'totalVAT',
//       headerName: 'VAT',
//       flex: 0.9,
//       minWidth: 120,
//       type: 'number',
//       resizable: true,
//       align: 'right',
//       headerAlign: 'right',
//       valueFormatter: (params) => `SAR ${params.value?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//     },
//     {
//       field: 'totalDiscount',
//       headerName: 'Discount',
//       flex: 0.9,
//       minWidth: 120,
//       type: 'number',
//       resizable: true,
//       align: 'right',
//       headerAlign: 'right',
//       valueFormatter: (params) => `SAR ${params.value?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//     },
//     {
//       field: 'totalPaid',
//       headerName: 'Paid',
//       flex: 0.9,
//       minWidth: 120,
//       type: 'number',
//       resizable: true,
//       align: 'right',
//       headerAlign: 'right',
//       valueFormatter: (params) => `SAR ${params.value?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//     },
//     {
//       field: 'totalBalance',
//       headerName: 'Balance',
//       flex: 0.9,
//       minWidth: 120,
//       type: 'number',
//       resizable: true,
//       align: 'right',
//       headerAlign: 'right',
//       valueFormatter: (params) => `SAR ${params.value?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//       cellClassName: (params) => params.value > 0 ? 'text-error' : '',
//     },
//     {
//       field: 'lastInvoiceDate',
//       headerName: 'Last Invoice',
//       flex: 0.9,
//       minWidth: 120,
//       sortable: true,
//       resizable: true,
//       headerAlign: 'left',
//       align: 'left',
//       valueFormatter: (params) => {
//         return new Date(params.value).toLocaleDateString('en-GB', {
//           day: '2-digit',
//           month: 'short',
//           year: 'numeric'
//         });
//       },
//     },
//   ];

//   // Summary cards data
//   const summaryCards = [
//     {
//       title: 'Total Customers',
//       value: totals?.totalCustomers || 0,
//       icon: <PersonIcon />,
//       color: '#4361ee',
//       format: (val) => val.toLocaleString(),
//     },
//     {
//       title: 'Total Invoices',
//       value: totals?.totalInvoices || 0,
//       icon: <ReceiptIcon />,
//       color: '#6a1b9a',
//       format: (val) => val.toLocaleString(),
//     },
//     {
//       title: 'Total Sales',
//       value: totals?.totalSales || 0,
//       icon: <SalesIcon />,
//       color: '#2e7d32',
//       format: (val) => `SAR ${val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//     },
//     {
//       title: 'Total Balance',
//       value: totals?.totalBalance || 0,
//       icon: <BalanceIcon />,
//       color: '#d32f2f',
//       format: (val) => `SAR ${val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
//     },
//   ];

//   return (
//     <Container maxWidth={false} sx={{ mt: 0.5, px: { xs: 0.5, sm: 1, md: 1, lg: 1 } }}>
//       {/* Header */}
//       <Box sx={{ mb: 0.5, display: 'flex', alignItems: 'center' }}>
//         <IconButton 
//           onClick={handleBack}
//           sx={{ mr: 1.5, bgcolor: 'rgba(67, 97, 238, 0.1)' }}
//         >
//           <BackIcon />
//         </IconButton>
//         <Box>
//           <Typography variant="h5" fontWeight="700" gutterBottom>
//             Customer Sales Report
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Sales performance per customer
//           </Typography>
//         </Box>
//       </Box>

//       {/* Filters */}
//       <Paper
//         elevation={0}
//         sx={{
//           p: 1,
//           mb: 0.5,
//           border: '1px solid',
//           borderColor: 'divider',
//           borderRadius: 0,
//         }}
//       >
//         <Typography variant="caption" fontWeight="600" sx={{ mb: 1, display: 'block', fontSize: '0.75rem' }}>
//           Filters
//         </Typography>
//         <LocalizationProvider dateAdapter={AdapterDateFns}>
//           <Grid container spacing={1} sx={{ mt: 0 }}>
//             <Grid item xs={12} sm={6} md={3}>
//               <TextField
//                 fullWidth
//                 select
//                 label="Customer"
//                 value={selectedCustomer || ''}
//                 onChange={(e) => {
//                   const value = e.target.value || '';
//                   console.log('Customer selected:', value);
//                   setSelectedCustomer(value);
//                   handleFilterChange('customerId', value);
//                 }}
//                 disabled={loading || customers.length === 0}
//                 size="small"
//                 sx={{
//                   '& .MuiOutlinedInput-root': {
//                     borderRadius: 0,
//                     height: '36px',
//                     fontSize: '0.875rem',
//                   },
//                   '& .MuiInputLabel-root': {
//                     fontSize: '0.875rem',
//                   },
//                   '& .MuiOutlinedInput-input': {
//                     padding: '8px 14px',
//                   },
//                 }}
//               >
//                 <MenuItem value="">All Customers</MenuItem>
//                 {customers.map((customer, index) => {
//                   console.log('Rendering customer:', customer);
//                   return (
//                     <MenuItem 
//                       key={`${customer.customerCode || customer._id || index}`} 
//                       value={customer.customerCode || customer._id || ''}
//                     >
//                       {customer.name || 'Unknown Customer'}
//                     </MenuItem>
//                   );
//                 })}
//               </TextField>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <DatePicker
//                 label="Start Date"
//                 value={filters.startDate}
//                 onChange={(date) => handleFilterChange('startDate', date)}
//                 slotProps={{
//                   textField: {
//                     size: 'small',
//                     fullWidth: true,
//                     sx: {
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 0,
//                         height: '36px',
//                         fontSize: '0.875rem',
//                       },
//                       '& .MuiInputLabel-root': {
//                         fontSize: '0.875rem',
//                       },
//                       '& .MuiOutlinedInput-input': {
//                         padding: '8px 14px',
//                       },
//                     },
//                   },
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <DatePicker
//                 label="End Date"
//                 value={filters.endDate}
//                 onChange={(date) => handleFilterChange('endDate', date)}
//                 slotProps={{
//                   textField: {
//                     size: 'small',
//                     fullWidth: true,
//                     sx: {
//                       '& .MuiOutlinedInput-root': {
//                         borderRadius: 0,
//                         height: '36px',
//                         fontSize: '0.875rem',
//                       },
//                       '& .MuiInputLabel-root': {
//                         fontSize: '0.875rem',
//                       },
//                       '& .MuiOutlinedInput-input': {
//                         padding: '8px 14px',
//                       },
//                     },
//                   },
//                 }}
//               />
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Button
//                 fullWidth
//                 variant="contained"
//                 onClick={handleApplyFilters}
//                 disabled={loading}
//                 sx={{
//                   borderRadius: 0,
//                   height: '36px',
//                   textTransform: 'none',
//                   fontWeight: 600,
//                   fontSize: '0.875rem',
//                 }}
//               >
//                 {loading ? <CircularProgress size={20} /> : 'Apply Filters'}
//               </Button>
//             </Grid>
//           </Grid>
//         </LocalizationProvider>
//       </Paper>

//       {/* Summary Cards */}
//       {totals && (
//         <Grid container spacing={1} sx={{ mb: 0.5 }}>
//           {summaryCards.map((card, index) => (
//             <Grid item xs={12} sm={6} md={3} key={index}>
//               <Paper
//                 elevation={0}
//                 sx={{
//                   p: 1.5,
//                   border: '1px solid',
//                   borderColor: 'divider',
//                   borderRadius: 0,
//                   borderLeft: `4px solid ${card.color}`,
//                 }}
//               >
//                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                   <Box
//                     sx={{
//                       width: 36,
//                       height: 36,
//                       borderRadius: '6px',
//                       bgcolor: `${card.color}15`,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       mr: 1.5,
//                     }}
//                   >
//                     {React.cloneElement(card.icon, { sx: { color: card.color, fontSize: 20 } })}
//                   </Box>
//                   <Box>
//                     <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
//                       {card.title}
//                     </Typography>
//                     <Typography variant="h6" fontWeight="700" sx={{ fontSize: '1.1rem' }}>
//                       {card.format(card.value)}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Paper>
//             </Grid>
//           ))}
//         </Grid>
//       )}

//       {/* Customer Sales DataGrid */}
//       <ReportDataGrid
//         data={reportData}
//         columns={columns}
//         loading={loading}
//         onRefresh={fetchReport}
//         exportFileName={`customer-sales-${new Date().toISOString().split('T')[0]}`}
//         pageSize={25}
//         height={700}
//         getRowId={(row) => row.customerCode}
//       />
//     </Container>
//   );
// };

// export default CustomerSalesReport;


import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  MenuItem,
  Button,
  CircularProgress,
  IconButton,
  Chip,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  Person as PersonIcon,
  Receipt as ReceiptIcon,
  TrendingUp as SalesIcon,
  AccountBalance as BalanceIcon,
  ArrowBack as BackIcon,
} from '@mui/icons-material';
import ReportDataGrid from '../components/ReportDataGrid';
import reportService from '../services/reportService';
import { useNavigate } from 'react-router-dom';
import image from '../assets/riyal.png';

// ── Reusable currency display ──────────────────────────────────────────────
const RiyalAmount = ({ value, sx = {} }) => (
  <Box
    component="span"
    sx={{ display: 'inline-flex', alignItems: 'center', gap: '3px', ...sx }}
  >
    <img
      src={image}
      alt="SAR"
      style={{ height: '13px', width: 'auto', verticalAlign: 'middle', flexShrink: 0 }}
    />
    {Number(value ?? 0).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}
  </Box>
);

const CustomerSalesReport = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [totals, setTotals] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [filters, setFilters] = useState({
    customerId: '',
    startDate: new Date(new Date().getFullYear(), 0, 1),
    endDate: new Date(),
  });
  const [selectedCustomer, setSelectedCustomer] = useState('');

  const fetchReport = async () => {
    try {
      setLoading(true);
      const params = {
        customerId: filters.customerId,
        startDate: filters.startDate?.toISOString().split('T')[0],
        endDate: filters.endDate?.toISOString().split('T')[0],
      };

      const response = await reportService.getCustomerSales(params);

      if (response.success) {
        setReportData(response.data || []);
        setTotals(response.totals);
        setCustomers(response.customers || []);
        console.log('Customers loaded:', response.customers?.length);
        console.log('Customers data:', response.customers);
        setSelectedCustomer(response.filters?.customerId || '');
      }
    } catch (error) {
      console.error('Error fetching customer sales report:', error);
      alert('Failed to fetch customer sales report. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({ ...prev, [field]: value }));
  };

  const handleApplyFilters = () => {
    fetchReport();
  };

  const handleBack = () => {
    navigate('/reports');
  };

  // ── Columns ──────────────────────────────────────────────────────────────
  const columns = [
    {
      field: 'customerName',
      headerName: 'Customer Name',
      flex: 1.2,
      minWidth: 200,
      sortable: true,
      resizable: true,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'customerCode',
      headerName: 'Customer Code',
      flex: 0.8,
      minWidth: 130,
      sortable: true,
      resizable: true,
      headerAlign: 'left',
      align: 'left',
    },
    {
      field: 'customerType',
      headerName: 'Type',
      flex: 0.6,
      minWidth: 80,
      resizable: true,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const type = params.value;
        const color =
          type === 'B2B'
            ? { bg: '#e3f2fd', text: '#1565c0' }
            : { bg: '#fff3e0', text: '#e65100' };
        return (
          <Chip
            label={type}
            size="small"
            sx={{
              bgcolor: color.bg,
              color: color.text,
              fontWeight: 600,
              fontSize: '0.7rem',
              height: '22px',
            }}
          />
        );
      },
    },
    {
      field: 'invoiceCount',
      headerName: 'Invoices',
      flex: 0.7,
      minWidth: 100,
      type: 'number',
      resizable: true,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'totalSales',
      headerName: 'Total Sales',
      flex: 1,
      minWidth: 150,
      type: 'number',
      resizable: true,
      align: 'right',
      headerAlign: 'right',
      renderCell: (params) => (
        <RiyalAmount value={params.value} sx={{ fontWeight: 700 }} />
      ),
    },
    {
      field: 'totalVAT',
      headerName: 'VAT',
      flex: 0.9,
      minWidth: 130,
      type: 'number',
      resizable: true,
      align: 'right',
      headerAlign: 'right',
      renderCell: (params) => <RiyalAmount value={params.value} />,
    },
    {
      field: 'totalDiscount',
      headerName: 'Discount',
      flex: 0.9,
      minWidth: 130,
      type: 'number',
      resizable: true,
      align: 'right',
      headerAlign: 'right',
      renderCell: (params) => <RiyalAmount value={params.value} />,
    },
    {
      field: 'totalPaid',
      headerName: 'Paid',
      flex: 0.9,
      minWidth: 130,
      type: 'number',
      resizable: true,
      align: 'right',
      headerAlign: 'right',
      renderCell: (params) => <RiyalAmount value={params.value} />,
    },
    {
      field: 'totalBalance',
      headerName: 'Balance',
      flex: 0.9,
      minWidth: 130,
      type: 'number',
      resizable: true,
      align: 'right',
      headerAlign: 'right',
      renderCell: (params) => (
        <RiyalAmount
          value={params.value}
          sx={{ color: params.value > 0 ? 'error.main' : 'inherit' }}
        />
      ),
    },
    {
      field: 'lastInvoiceDate',
      headerName: 'Last Invoice',
      flex: 0.9,
      minWidth: 120,
      sortable: true,
      resizable: true,
      headerAlign: 'left',
      align: 'left',
      valueFormatter: (params) =>
        new Date(params.value).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        }),
    },
  ];

  // ── Summary cards ─────────────────────────────────────────────────────────
  const summaryCards = [
    {
      title: 'Total Customers',
      value: totals?.totalCustomers || 0,
      icon: <PersonIcon />,
      color: '#4361ee',
      format: (val) => val.toLocaleString(),
    },
    {
      title: 'Total Invoices',
      value: totals?.totalInvoices || 0,
      icon: <ReceiptIcon />,
      color: '#6a1b9a',
      format: (val) => val.toLocaleString(),
    },
    {
      title: 'Total Sales',
      value: totals?.totalSales || 0,
      icon: <SalesIcon />,
      color: '#2e7d32',
      isAmount: true,
    },
    {
      title: 'Total Balance',
      value: totals?.totalBalance || 0,
      icon: <BalanceIcon />,
      color: '#d32f2f',
      isAmount: true,
    },
  ];

  return (
    <Container maxWidth={false} sx={{ mt: 0.5, px: { xs: 0.5, sm: 1, md: 1, lg: 1 } }}>
      {/* Header */}
      <Box sx={{ mb: 0.5, display: 'flex', alignItems: 'center' }}>
        <IconButton
          onClick={handleBack}
          sx={{ mr: 1.5, bgcolor: 'rgba(67, 97, 238, 0.1)' }}
        >
          <BackIcon />
        </IconButton>
        <Box>
          <Typography variant="h5" fontWeight="700" gutterBottom>
            Customer Sales Report
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Sales performance per customer
          </Typography>
        </Box>
      </Box>

      {/* Filters */}
      <Paper
        elevation={0}
        sx={{
          p: 1,
          mb: 0.5,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 0,
        }}
      >
        <Typography
          variant="caption"
          fontWeight="600"
          sx={{ mb: 1, display: 'block', fontSize: '0.75rem' }}
        >
          Filters
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Grid container spacing={1} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                select
                label="Customer"
                value={selectedCustomer || ''}
                onChange={(e) => {
                  const value = e.target.value || '';
                  console.log('Customer selected:', value);
                  setSelectedCustomer(value);
                  handleFilterChange('customerId', value);
                }}
                disabled={loading || customers.length === 0}
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 0,
                    height: '36px',
                    fontSize: '0.875rem',
                  },
                  '& .MuiInputLabel-root': { fontSize: '0.875rem' },
                  '& .MuiOutlinedInput-input': { padding: '8px 14px' },
                }}
              >
                <MenuItem value="">All Customers</MenuItem>
                {customers.map((customer, index) => {
                  console.log('Rendering customer:', customer);
                  return (
                    <MenuItem
                      key={`${customer.customerCode || customer._id || index}`}
                      value={customer.customerCode || customer._id || ''}
                    >
                      {customer.name || 'Unknown Customer'}
                    </MenuItem>
                  );
                })}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DatePicker
                label="Start Date"
                value={filters.startDate}
                onChange={(date) => handleFilterChange('startDate', date)}
                slotProps={{
                  textField: {
                    size: 'small',
                    fullWidth: true,
                    sx: {
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 0,
                        height: '36px',
                        fontSize: '0.875rem',
                      },
                      '& .MuiInputLabel-root': { fontSize: '0.875rem' },
                      '& .MuiOutlinedInput-input': { padding: '8px 14px' },
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <DatePicker
                label="End Date"
                value={filters.endDate}
                onChange={(date) => handleFilterChange('endDate', date)}
                slotProps={{
                  textField: {
                    size: 'small',
                    fullWidth: true,
                    sx: {
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 0,
                        height: '36px',
                        fontSize: '0.875rem',
                      },
                      '& .MuiInputLabel-root': { fontSize: '0.875rem' },
                      '& .MuiOutlinedInput-input': { padding: '8px 14px' },
                    },
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleApplyFilters}
                disabled={loading}
                sx={{
                  borderRadius: 0,
                  height: '36px',
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: '0.875rem',
                }}
              >
                {loading ? <CircularProgress size={20} /> : 'Apply Filters'}
              </Button>
            </Grid>
          </Grid>
        </LocalizationProvider>
      </Paper>

      {/* Summary Cards */}
      {totals && (
        <Grid container spacing={1} sx={{ mb: 0.5 }}>
          {summaryCards.map((card, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 1.5,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 0,
                  borderLeft: `4px solid ${card.color}`,
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      width: 36,
                      height: 36,
                      borderRadius: '6px',
                      bgcolor: `${card.color}15`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mr: 1.5,
                    }}
                  >
                    {React.cloneElement(card.icon, {
                      sx: { color: card.color, fontSize: 20 },
                    })}
                  </Box>
                  <Box>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontSize: '0.7rem' }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      variant="h6"
                      fontWeight="700"
                      sx={{ fontSize: '1.1rem' }}
                    >
                      {card.isAmount ? (
                        <RiyalAmount value={card.value} sx={{ fontSize: '1.1rem', fontWeight: 700 }} />
                      ) : (
                        card.format(card.value)
                      )}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Customer Sales DataGrid */}
      <ReportDataGrid
        data={reportData}
        columns={columns}
        loading={loading}
        onRefresh={fetchReport}
        exportFileName={`customer-sales-${new Date().toISOString().split('T')[0]}`}
        pageSize={25}
        height={700}
        getRowId={(row) => row.customerCode}
      />
    </Container>
  );
};

export default CustomerSalesReport;